import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Button from "@mui/material/Button";
import Storage from "../libs/storage";

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    animation: fadeIn 0.2s ease-in-out;

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

const AnnouncementContainer = styled.div`
    position: relative;
    display: flex;
    width: 600px;
    padding: 40px;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    border-radius: 8px;
    background: #ffffff;
    border: 1px solid rgb(144, 144, 144);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
    animation: slideUp 0.3s ease-in-out;

    @keyframes slideUp {
        from {
            transform: translateY(20px);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }

    @media (max-width: 800px) {
        width: calc(100% - 80px);
        max-width: 100%;
        padding: 24px;
    }
`;

const CloseButton = styled.img`
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
    width: 20px;
    height: 20px;
    transition: opacity 0.2s ease-in-out;

    &:hover {
        opacity: 0.6;
    }
`;

const Title = styled.h2`
    color: #181122;
    font-family: Montserrat, Arial, Helvetica, sans-serif;
    font-size: 18px;
    font-weight: 600;
    line-height: normal;
    margin: 0;
    margin-bottom: 4px;
    text-transform: uppercase;
`;

const TitleLine = styled.div`
    width: 96px;
    height: 2px;
    background: #57c4c2;
    margin-bottom: 16px;
`;

const Description = styled.p`
    color: #181122;
    font-family: Montserrat, Arial, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    margin: 0;
    margin-bottom: 24px;
    text-align: left;
`;

const FeaturesList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0 0 24px 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const FeatureItem = styled.li`
    color: #181122;
    font-family: Montserrat, Arial, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    display: flex;
    align-items: center;
    gap: 8px;

    &:before {
        content: "✓";
        color: #57c4c2;
        font-weight: bold;
        font-size: 16px;
    }
`;

const GhostButton = styled(Button)`
    background-color: transparent !important;
    color: #909090 !important;
    font-family: Montserrat, Arial, Helvetica, sans-serif !important;
    font-size: 12px !important;
    font-weight: 500 !important;
    text-transform: capitalize !important;
    border: none !important;
    padding: 8px !important;
    min-width: auto !important;
    transition: color 0.2s ease-in-out !important;

    &:hover {
        background-color: transparent !important;
        color: #181122 !important;
    }

    @media (max-width: 500px) {
        width: 100%;
    }
`;

export default function AnnouncementFeaturePlansInvoices() {
    const [visible, setVisible] = useState(false);
    const ANNOUNCEMENT_KEY = "announcement_planos_faturas_v1";

    useEffect(() => {
        const checkIfShouldShow = async () => {
            try {
                const storage = Storage();
                const hasSeenAnnouncement = await storage.getItem(ANNOUNCEMENT_KEY);
                if (!hasSeenAnnouncement) {
                    setVisible(true);
                }
            } catch (error) {
                console.error("Error checking announcement status:", error);
            }
        };

        checkIfShouldShow();
    }, []);

    const handleClose = async () => {
        try {
            const storage = Storage();
            await storage.saveItem(ANNOUNCEMENT_KEY, true);
            setVisible(false);
        } catch (error) {
            console.error("Error closing announcement:", error);
        }
    };

    if (!visible) {
        return null;
    }

    return (
        <ModalOverlay onClick={handleClose}>
            <AnnouncementContainer onClick={(e) => e.stopPropagation()}>
                <CloseButton
                    src="/img/modal_close.svg"
                    onClick={handleClose}
                    alt="Fechar"
                    data-testid="close-announcement"
                />

                <Title>Novidade no Zag: Planos e Faturas</Title>
                <TitleLine />

                <Description>
                    Agora você pode gerenciar upgrade e downgrade de plano e acompanhar suas faturas
                    em uma nova experiência integrada.
                </Description>

                <FeaturesList>
                    <FeatureItem>Upgrade e downgrade de planos conforme sua necessidade</FeatureItem>
                    <FeatureItem>Histórico completo de faturas e cobranças</FeatureItem>
                    <FeatureItem>Gestão simplificada de sua assinatura</FeatureItem>
                </FeaturesList>

                <div style={{ width: "100%", textAlign: "center" }}>
                    <GhostButton onClick={handleClose} data-testid="btn-close">
                        Fechar
                    </GhostButton>
                </div>
            </AnnouncementContainer>
        </ModalOverlay>
    );
}
